var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.75,
    height: 38.75,
    x: 0.625,
    y: 0.625,
    stroke: "#6E3FF3",
    strokeWidth: 1.25,
    rx: 6.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__a)",
    d: "M28.137 6.875h4.34c.52 0 .812.596.495 1.007l-9.242 11.96a1.25 1.25 0 0 0 .017 1.552l9.179 11.338a.625.625 0 0 1-.486 1.018h-4.32a1.25 1.25 0 0 1-.995-.492l-9.061-11.893a1.25 1.25 0 0 1-.017-1.493L27.126 7.39a1.25 1.25 0 0 1 1.01-.515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__b)",
    d: "m18.54 12.58-2.27-5.902a1.25 1.25 0 0 0-1.993-.488l-7.771 6.856a1.25 1.25 0 0 0 .35 2.094l7.74 3.186a1.25 1.25 0 0 0 1.57-.548l2.3-4.142c.18-.324.207-.71.074-1.056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__c)",
    d: "M11.758 33.75h3.867c.69 0 1.25-.56 1.25-1.25V20.427c0-.58-.471-1.052-1.052-1.052-.493 0-.931.312-1.093.777L10.578 32.09a1.25 1.25 0 0 0 1.18 1.661"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#101828",
    d: "M52.514 27V12.455h3.075v6.413h.192l5.235-6.413h3.686l-5.398 6.512L64.766 27h-3.68l-3.984-5.98-1.512 1.846V27zm13.816 0V16.09h3.026V27zm1.52-12.315q-.675 0-1.158-.448a1.45 1.45 0 0 1-.476-1.086q0-.626.476-1.073a1.63 1.63 0 0 1 1.158-.454q.675 0 1.15.454.484.447.484 1.073 0 .631-.483 1.086a1.62 1.62 0 0 1-1.151.448m9.132 1.406v2.273h-6.57V16.09zm-5.078-2.614h3.025v10.17q0 .42.128.654a.7.7 0 0 0 .355.32q.234.092.54.092.213 0 .426-.035.213-.043.327-.064l.476 2.251a9 9 0 0 1-.64.163 5 5 0 0 1-1 .121q-1.095.043-1.919-.291a2.68 2.68 0 0 1-1.27-1.037q-.456-.703-.448-1.776zm11.303 13.736q-1.683 0-2.898-.682a4.67 4.67 0 0 1-1.86-1.946q-.654-1.265-.654-2.99 0-1.683.654-2.954a4.83 4.83 0 0 1 1.84-1.982q1.191-.71 2.797-.71 1.08 0 2.01.348.938.34 1.634 1.03.703.689 1.094 1.733.39 1.035.39 2.429v.83h-9.211v-1.874h6.363q0-.654-.284-1.158a2.04 2.04 0 0 0-.788-.788 2.25 2.25 0 0 0-1.158-.292q-.69 0-1.221.32a2.24 2.24 0 0 0-.824.845q-.3.525-.306 1.172v1.783q0 .81.299 1.399.305.59.859.909t1.314.32q.504 0 .923-.142t.717-.427.455-.696l2.798.185a3.8 3.8 0 0 1-.873 1.761q-.654.747-1.69 1.165-1.03.412-2.38.412m15.458-8.011-2.77.17a1.43 1.43 0 0 0-.305-.639 1.6 1.6 0 0 0-.618-.462 2.1 2.1 0 0 0-.902-.177q-.703 0-1.186.298-.483.291-.483.781 0 .39.313.66.312.27 1.072.434l1.974.398q1.591.327 2.373 1.05.78.725.78 1.904 0 1.073-.631 1.882-.626.81-1.719 1.265-1.086.447-2.507.447-2.166 0-3.452-.902-1.279-.91-1.498-2.471l2.976-.157q.134.66.653 1.009.519.34 1.328.34.795 0 1.278-.305.49-.312.498-.802a.84.84 0 0 0-.348-.675q-.341-.27-1.052-.412l-1.889-.376q-1.597-.32-2.379-1.108-.774-.789-.774-2.01 0-1.052.568-1.811.576-.76 1.612-1.172 1.043-.412 2.444-.412 2.066 0 3.252.873 1.194.874 1.392 2.38M100.276 27V12.455h3.075v6.001h6.243v-6.001h3.068V27h-3.068v-6.009h-6.243V27zm14.322 0V12.455h5.738q1.648 0 2.813.589 1.171.582 1.783 1.655.618 1.065.618 2.507 0 1.449-.625 2.493-.626 1.037-1.812 1.59-1.178.555-2.855.555h-3.842v-2.472h3.345q.88 0 1.463-.241.582-.242.867-.725.291-.483.291-1.2 0-.724-.291-1.222-.285-.497-.874-.752-.582-.264-1.47-.263h-2.074V27zm7.855-6.62 3.615 6.62h-3.395l-3.537-6.62z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 33.75,
    x2: 17.5,
    y1: 20.313,
    y2: 20.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB90F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 11.875,
    x2: 11.875,
    y1: 5,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB90F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x1: 13.438,
    x2: 13.438,
    y1: 33.75,
    y2: 19.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB90F8"
  })))));
};
export default SvgLogo;